<template>
    <div id="welcome-screen" class="welcome-screen position-relative">
        <div class="welcome-screen-overlay"></div>
        <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop">
            <source src="@/assets/video_ru.mp4" type="video/mp4">
        </video> 
        <img class="welcome-screen-logo" src="@/assets/images/logo.png" alt="kickoff-logo" width="250">
        <br>
        <div class="welcome-screen-text">
            <h4>МОСКВА</h4>
            <p>31 января 2026 года<br><br><span>МТС Live Холл  г. Москва, <br>ш. Энтузиастов, 5, стр. 2</span></p>
        </div>
    </div>
</template>

<script setup>
    const { onMounted, ref }=require("@vue/runtime-core")
    import SwiperLightBox from '../testSwiperLightBox.vue'

    const toggler = ref(false);

    function welcomeScreenSetOffset() {
        const navbar = document.getElementById('navbar')
        const welcomeScreen = document.getElementById('welcome-screen')
        const navbarHeight = navbar.offsetHeight
        if(welcomeScreen) welcomeScreen.style.marginTop = `-${navbarHeight}px`
    }

    window.addEventListener("load", (event) => {
        welcomeScreenSetOffset()
    });

    /* onMounted(() => {
        welcomeScreenSetOffset()
    }) */
</script>

<style>
    .welcome-screen {
        height: 100vh;
        margin-top: -90px;
    }

    .welcome-screen video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .welcome-screen-logo {
        position: absolute;
        top: 47%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 50%;
    }

    .welcome-screen-text h4 {
        color: white;
    }

    .welcome-screen-text p {
        color: white;
        white-space: nowrap;
    }

    .welcome-screen-text span {
        color: #f48257;
    }

    .welcome-screen-text {
        text-align: center;
        position: absolute;
        top: 65%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 50%;
    }

    .welcome-screen-overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.75);
    }
</style>